import { defineComponent as _defineComponent } from 'vue'
import SpringFooterModule from '../spring-footer-module/index.vue';
import CardContentLoader from './module-skeleton.vue';
import { useGlobalBi } from '@/hooks/use-global-bi';
import { CustomException, elk } from '@tencent/ppd-base-libs';
import { ProgressBar } from '@tencent/wphk-act-base-ui';
import { to } from '@tencent/wphk-base-utils';
import { BaseComponent } from '@tencent/wphk-components-content-loader';
import TextFormatter from '@tencent/wphk-components-text-formatter/index.vue';
import { InfoIcon } from '@tencent/wphk-icon-vue';
import { computed, onMounted, ref, toRefs } from 'vue';
import ActInfoDialog from './act-info-dialog.vue';
import { initPayAct, payAct } from './business/pay-act';
import { usePayActList } from './hooks/use-pay-act-item';
import JoinSuccessDialog from './join-success-dialog.vue';
import PayActItemVue from './pay-act-item.vue';
import { useMerchantInfo } from '@/store/merchant-info-module';
import { useActConfigStore } from '../../store/act-config';
import { usePromoterAct } from '../../hooks/use-promoter-act';
import { biBrow } from '@tencent/fit-bi-sdk';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { targetActConfig } = useActConfigStore();
const {
  disSource,
  promoterInfo,
} = usePromoterAct();
/** 活动介绍弹窗 */
const actInfoDialog = ref();
/** 报名成功弹窗 */
const successDialog = ref();
const { getBiExt } = useGlobalBi();
const customBiExt = computed(() => ({
  ...getBiExt(),
  fpromotercode: promoterInfo.value.promoterCode,
  fcanJoin: `${promoterInfo.value.isPromoterAct}`,
}));
const { actList } = toRefs(payAct);
const skinColorStyle = computed(() => {
  const skinColor = targetActConfig?.payTaskModule.skinColor;
  if (skinColor) {
    return `background: ${skinColor}`;
  }
});
const skinImgUrl = computed(() => {
  const skinImgUrl = targetActConfig?.payTaskModule.skinImgUrl;
  return skinImgUrl;
});
/** 计算进度条 */
const completeCount = computed(() => {
  const { inProcessTasks } = usePayActList(actList.value);
  const inProcessTaskCnt = inProcessTasks.length;
  const totalTaskCnt = actList.value.length;
  return inProcessTaskCnt === totalTaskCnt ? inProcessTaskCnt : inProcessTaskCnt - 0.5;
});
const onClickInfo = () => {
  actInfoDialog.value.showActInfoDialog();
};
const handleJoinSuccess = () => {
  successDialog.value.showSuccessDialog();
};
const isNeedPreloadSuccess = computed(() => {
  const { isFirstTaskReceive } = usePayActList(actList.value);
  return !isFirstTaskReceive;
});

const isInitDone = ref(false);
const isInitSuccess = ref(false);
onMounted(async () => {
  const [err] = await to(initPayAct({
    taskName: targetActConfig?.payTaskModule.taskName,
    signInActId: targetActConfig?.payTaskModule.signInActId,
    disSource: disSource.value,
  }));
  isInitDone.value = true;
  if (err || actList.value.length === 0) {
    isInitSuccess.value = false;
    throw new CustomException(err, 'initPayTaskFail', '初始化多笔多赏模块失败');
  }
  isInitSuccess.value = true;
  reportBrow();
  if (promoterInfo.value.isPromoterAct) {
    biBrow('pay-task-module.promoter-module|推广员场景曝光', customBiExt.value);
  }
});

const reportBrow = () => {
  const { spId, merchantId } = useMerchantInfo();
  elk({
    key: 'payTaskBrow',
    str3: spId,
    str4: merchantId,
  });
};

return { __sfc: true,targetActConfig, disSource, promoterInfo, actInfoDialog, successDialog, getBiExt, customBiExt, actList, skinColorStyle, skinImgUrl, completeCount, onClickInfo, handleJoinSuccess, isNeedPreloadSuccess, isInitDone, isInitSuccess, reportBrow, SpringFooterModule, CardContentLoader, ProgressBar, BaseComponent, TextFormatter, InfoIcon, ActInfoDialog, JoinSuccessDialog, PayActItemVue }
}

})